import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: require('../views/Home.vue').default,
  },
  {
    path: '/quiz',
    name: 'Quiz',
    component: require('../views/Quiz.vue').default,
  },
  {
    path: '/bag',
    name: 'Bag',
    component: require('../views/Bag.vue').default,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
